import adminDashboardService from '../../services/admin/AdminDashboardService'

/**
 * Estado inicial isolado em uma factory para que RESET possa devolver o módulo
 * ao ponto zero. A tela chama resetRanking() no beforeDestroy(): sair de
 * /relatorios/itens não deve deixar a página pendurada no Vuex.
 */
const initialState = () => ({
  itens: [],
  moeda: null,
  totalOrcamentos: 0,
  truncado: false,
  total: 0,
  totalRanking: 0,
  currentPage: 1,
  perPage: 25,
  lastPage: 1,
  loaded: false,
  loading: false,
})

/**
 * Sequência das requisições em voo. Trocar período, filial, ordenação ou página
 * em sequência rápida deixa mais de uma consulta pendente, e a mais antiga não
 * pode sobrescrever a resposta da mais recente (nem desligar o loading dela).
 */
let requestId = 0

/**
 * Ranking completo de itens (/admin/relatorios/itens, #29).
 *
 * Módulo próprio, e não uma fatia do adminDashboardModule: aquele é zerado no
 * beforeDestroy() de /inicio, que dispara justamente na navegação para esta
 * tela — o RESET chegaria depois do created() daqui e apagaria a carga nova.
 */
export const adminItensRankingModule = {
  namespaced: true,

  state: initialState(),

  mutations: {
    SET_RANKING(state, payload) {
      state.itens = payload?.data || []
      state.moeda = payload?.moeda || null
      state.totalOrcamentos = Number(payload?.totalOrcamentos) || 0
      state.truncado = Boolean(payload?.truncado)
      state.total = Number(payload?.total) || 0
      state.totalRanking = Number(payload?.totalRanking) || 0
      state.currentPage = Number(payload?.current_page) || 1
      state.perPage = Number(payload?.per_page) || initialState().perPage
      state.lastPage = Number(payload?.last_page) || 1
      state.loaded = true
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    RESET(state) {
      Object.assign(state, initialState())
    },
  },

  actions: {
    async fetchRanking({ commit }, params = {}) {
      const current = ++requestId
      commit('SET_LOADING', true)

      try {
        const data = await adminDashboardService.getRankingItens(params)

        if (current !== requestId) return data

        commit('SET_RANKING', data)
        return data
      } finally {
        if (current === requestId) commit('SET_LOADING', false)
      }
    },

    resetRanking({ commit }) {
      // Invalida o que estiver em voo: sair da tela não pode repovoar o módulo
      // depois do RESET.
      requestId++
      commit('RESET')
    },
  },

  getters: {
    itens: (state) => state.itens,
    moeda: (state) => state.moeda,
    totalOrcamentos: (state) => state.totalOrcamentos,
    truncado: (state) => state.truncado,
    total: (state) => state.total,
    totalRanking: (state) => state.totalRanking,
    currentPage: (state) => state.currentPage,
    perPage: (state) => state.perPage,
    lastPage: (state) => state.lastPage,
    loaded: (state) => state.loaded,
    loading: (state) => state.loading,
  },
}
